<template>
  <div class="text-center">
    <p class="lead">Cargando...</p>
    <b-spinner variant="primary" label="Spinning"></b-spinner>
  </div>
</template>

<script>
export default {
  name: 'LoadingData'
}
</script>
